import { isAudioDeviceAvailable, isVideoDeviceAvailable } from './device';

export const FRAME_RATE = 24;
export const VIDEO_WIDTH = 1280;
export const VIDEO_HEIGHT = 720;

export function getMediaStreamConstraints(constraints: MediaStreamConstraints) {
    const newConstraints = { ...constraints };

    if (typeof constraints.video === 'object') {
        newConstraints.video = {
            ...constraints.video,
            width: VIDEO_WIDTH,
            height: VIDEO_HEIGHT,
            frameRate: FRAME_RATE,
        };
    }

    return newConstraints;
}

export interface GetContraintsOptions {
    audioDeviceId?: string;
    videoDeviceId?: string;
    type?: 'ideal' | 'exact';
    devices: MediaDeviceInfo[];
}

export function getContraints({
    type = 'ideal',
    audioDeviceId,
    videoDeviceId,
    devices,
}: GetContraintsOptions): MediaStreamConstraints {
    const useDefaultAudio =
        typeof audioDeviceId !== 'undefined' && !isAudioDeviceAvailable(audioDeviceId, devices);
    const useDefaultVideo =
        typeof videoDeviceId !== 'undefined' && !isVideoDeviceAvailable(videoDeviceId, devices);

    const constraints: MediaStreamConstraints = getMediaStreamConstraints({
        audio: useDefaultAudio ? { deviceId: '' } : { deviceId: { [type]: audioDeviceId } },
        video: useDefaultVideo ? { deviceId: '' } : { deviceId: { [type]: videoDeviceId } },
    });

    if (typeof audioDeviceId === 'undefined') {
        delete constraints.audio;
    }
    if (typeof videoDeviceId === 'undefined') {
        delete constraints.video;
    }
    return constraints;
}
